<template>
  <div>
    <div v-if="editor" class="editor">
      <b-row
        v-show="!disabled && (showMenu == 'advanced' || showMenu == 'basic' || showDynamicMenu)"
        :class="['editorBackground',  { 'mx-0': text_area_question }]"
      >
        <b-col align="center" class="my-2 p-0">
          <b-button-group>
            <b-button
              :variant="editor.isActive('bold') ? 'light' : 'outline'"
              :style="editor.isActive('bold') ? 'opacity: 0.9' : ''"
              @click="editor.chain().focus().toggleBold().run()"
              :disabled="!editor.can().chain().focus().toggleBold().run()"
              v-b-tooltip.hover
              :title="$t('bold')"
              size="sm"
            >
              <b-icon-type-bold :variant="editor.isActive('bold') ? 'primary' : 'white'" />
            </b-button>

            <b-button
              v-show="showMenu == 'advanced'"
              :variant="editor.isActive('italic') ? 'light' : 'outline'"
              :style="editor.isActive('italic') ? 'opacity: 0.9' : ''"
              @click="editor.chain().focus().toggleItalic().run()"
              :disabled="!editor.can().chain().focus().toggleItalic().run()"
              v-b-tooltip.hover
              :title="$t('italic')"
              size="sm"
            >
              <b-icon-type-italic :variant="editor.isActive('italic') ? 'primary' : 'white'" />
            </b-button>

            <b-button
              v-show="showMenu == 'advanced'"
              :variant="editor.isActive('underline') ? 'light' : 'outline'"
              :style="editor.isActive('underline') ? 'opacity: 0.9' : ''"
              @click="editor.chain().focus().toggleUnderline().run()"
              :disabled="!editor.can().chain().focus().toggleUnderline().run()"
              v-b-tooltip.hover
              :title="$t('underlined')"
              size="sm"
            >
              <b-icon-type-underline :variant="editor.isActive('underline') ? 'primary' : 'white'" />
            </b-button>

            <b-button
              v-show="showMenu == 'advanced'"
              :variant="editor.isActive('strike') ? 'light' : 'outline'"
              :style="editor.isActive('strike') ? 'opacity: 0.9' : ''"
              @click="editor.chain().focus().toggleStrike().run()"
              v-b-tooltip.hover
              :title="$t('strikethrough')"
              size="sm"
            >
              <b-icon-type-strikethrough :variant="editor.isActive('strike') ? 'primary' : 'white'" />
            </b-button>
          </b-button-group>

          <b-button-group>
            <b-button
              v-show="showMenu == 'advanced'"
              :variant="
                showTextColor ||
                editor.isActive('textStyle', { color: 'purple' }) ||
                editor.isActive('textStyle', { color: 'pink' }) ||
                editor.isActive('textStyle', { color: 'red' }) ||
                editor.isActive('textStyle', { color: 'orange' }) ||
                editor.isActive('textStyle', { color: 'yellow' }) ||
                editor.isActive('textStyle', { color: 'blue' }) ||
                editor.isActive('textStyle', { color: 'teal' }) ||
                editor.isActive('textStyle', { color: 'green' }) ||
                editor.isActive('textStyle', { color: 'black' })
                  ? 'light'
                  : 'outline'
              "
              :style="
                showTextColor ||
                editor.isActive('textStyle', { color: 'purple' }) ||
                editor.isActive('textStyle', { color: 'pink' }) ||
                editor.isActive('textStyle', { color: 'red' }) ||
                editor.isActive('textStyle', { color: 'orange' }) ||
                editor.isActive('textStyle', { color: 'yellow' }) ||
                editor.isActive('textStyle', { color: 'blue' }) ||
                editor.isActive('textStyle', { color: 'teal' }) ||
                editor.isActive('textStyle', { color: 'green' }) ||
                editor.isActive('textStyle', { color: 'black' })
                  ? 'opacity: 0.9'
                  : ''
              "
              @click="
                showTextColor = !showTextColor;
                showHighlightColor = false;
              "
              v-b-tooltip.hover
              :title="$t('textColor')"
              size="sm"
            >
              <b-icon-type
                :variant="
                  showTextColor ||
                  editor.isActive('textStyle', { color: 'purple' }) ||
                  editor.isActive('textStyle', { color: 'pink' }) ||
                  editor.isActive('textStyle', { color: 'red' }) ||
                  editor.isActive('textStyle', { color: 'orange' }) ||
                  editor.isActive('textStyle', { color: 'yellow' }) ||
                  editor.isActive('textStyle', { color: 'blue' }) ||
                  editor.isActive('textStyle', { color: 'teal' }) ||
                  editor.isActive('textStyle', { color: 'green' }) ||
                  editor.isActive('textStyle', { color: 'black' })
                    ? 'primary'
                    : 'white'
                "
              />
            </b-button>

            <b-button
              v-show="showMenu == 'advanced'"
              :variant="
                showHighlightColor ||
                editor.isActive('highlight', { color: 'purple' }) ||
                editor.isActive('highlight', { color: 'pink' }) ||
                editor.isActive('highlight', { color: 'red' }) ||
                editor.isActive('highlight', { color: 'orange' }) ||
                editor.isActive('highlight', { color: 'yellow' }) ||
                editor.isActive('highlight', { color: 'blue' }) ||
                editor.isActive('highlight', { color: 'teal' }) ||
                editor.isActive('highlight', { color: 'green' }) ||
                editor.isActive('highlight', { color: 'black' })
                  ? 'light'
                  : 'outline'
              "
              :style="
                showHighlightColor ||
                editor.isActive('highlight', { color: 'purple' }) ||
                editor.isActive('highlight', { color: 'pink' }) ||
                editor.isActive('highlight', { color: 'red' }) ||
                editor.isActive('highlight', { color: 'orange' }) ||
                editor.isActive('highlight', { color: 'yellow' }) ||
                editor.isActive('highlight', { color: 'blue' }) ||
                editor.isActive('highlight', { color: 'teal' }) ||
                editor.isActive('highlight', { color: 'green' }) ||
                editor.isActive('highlight', { color: 'black' })
                  ? 'opacity: 0.9'
                  : ''
              "
              @click="
                showHighlightColor = !showHighlightColor;
                showTextColor = false;
              "
              v-b-tooltip.hover
              :title="$t('highlightColor')"
              size="sm"
            >
              <b-icon-pencil
                :variant="
                  showHighlightColor ||
                  editor.isActive('highlight', { color: 'purple' }) ||
                  editor.isActive('highlight', { color: 'pink' }) ||
                  editor.isActive('highlight', { color: 'red' }) ||
                  editor.isActive('highlight', { color: 'orange' }) ||
                  editor.isActive('highlight', { color: 'yellow' }) ||
                  editor.isActive('highlight', { color: 'blue' }) ||
                  editor.isActive('highlight', { color: 'teal' }) ||
                  editor.isActive('highlight', { color: 'green' }) ||
                  editor.isActive('highlight', { color: 'black' })
                    ? 'primary'
                    : 'white'
                "
              />
            </b-button>
          </b-button-group>

          <!-- <button
          @click="editor.chain().focus().toggleCode().run()"
          :disabled="!editor.can().chain().focus().toggleCode().run()"
          :class="{ 'is-active': editor.isActive('code') }">
          code
          </button> -->

          <!-- <button @click="editor.chain().focus().unsetAllMarks().run()">clear marks</button>
          <button @click="editor.chain().focus().clearNodes().run()">clear nodes
          </button> -->

          <!-- Text alignment -->
          <b-button-group>
            <b-button
              v-show="showMenu == 'advanced'"
              :variant="editor.isActive({ textAlign: 'left' }) ? 'light' : 'outline'"
              :style="editor.isActive({ textAlign: 'left' }) ? 'opacity: 0.9' : ''"
              @click="editor.chain().focus().setTextAlign('left').run()"
              v-b-tooltip.hover
              :title="$t('alignleft')"
              size="sm"
            >
              <b-icon-text-left :variant="editor.isActive({ textAlign: 'left' }) ? 'primary' : 'white'" />
            </b-button>

            <b-button
              v-show="showMenu == 'advanced'"
              :variant="editor.isActive({ textAlign: 'center' }) ? 'light' : 'outline'"
              :style="editor.isActive({ textAlign: 'center' }) ? 'opacity: 0.9' : ''"
              @click="editor.chain().focus().setTextAlign('center').run()"
              v-b-tooltip.hover
              :title="$t('aligncenter')"
              size="sm"
            >
              <b-icon-text-center :variant="editor.isActive({ textAlign: 'center' }) ? 'primary' : 'white'" />
            </b-button>

            <b-button
              v-show="showMenu == 'advanced'"
              :variant="editor.isActive({ textAlign: 'right' }) ? 'light' : 'outline'"
              :style="editor.isActive({ textAlign: 'right' }) ? 'opacity: 0.9' : ''"
              @click="editor.chain().focus().setTextAlign('right').run()"
              v-b-tooltip.hover
              :title="$t('alignright')"
              size="sm"
            >
              <b-icon-text-right :variant="editor.isActive({ textAlign: 'right' }) ? 'primary' : 'white'" />
            </b-button>
          </b-button-group>

          <!-- Headings -->
          <b-button-group>
            <b-button
              v-show="showMenu == 'advanced'"
              :variant="editor.isActive('heading', { level: 1 }) ? 'light' : 'outline'"
              :style="editor.isActive('heading', { level: 1 }) ? 'opacity: 0.9' : ''"
              @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
              v-b-tooltip.hover
              :title="$t('heading') + ' 1'"
              size="sm"
            >
              <b-icon-type-h1 :variant="editor.isActive('heading', { level: 1 }) ? 'primary' : 'white'" />
            </b-button>

            <b-button
              :variant="editor.isActive('heading', { level: 2 }) ? 'light' : 'outline'"
              :style="editor.isActive('heading', { level: 2 }) ? 'opacity: 0.9' : ''"
              @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
              v-b-tooltip.hover
              :title="$t('heading') + ' 2'"
              size="sm"
            >
              <b-icon-type-h2 :variant="editor.isActive('heading', { level: 2 }) ? 'primary' : 'white'" />
            </b-button>

            <b-button
              :variant="editor.isActive('heading', { level: 3 }) ? 'light' : 'outline'"
              :style="editor.isActive('heading', { level: 3 }) ? 'opacity: 0.9' : ''"
              @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
              v-b-tooltip.hover
              :title="$t('heading') + ' 3'"
              size="sm"
            >
              <b-icon-type-h3 :variant="editor.isActive('heading', { level: 3 }) ? 'primary' : 'white'" />
            </b-button>

            <!-- <b-button
                  :variant="editor.isActive('heading', { level: 4 }) ? '' : 'outline'"
                  @click="editor.chain().focus().toggleHeading({ level: 4 }).run()"
                  v-b-tooltip.hover
                  :title="$t('heading') + ' 4'"
                >
                  H4
                </b-button>
                <b-button
                  :variant="editor.isActive('heading', { level: 5 }) ? '' : 'outline'"
                  @click="editor.chain().focus().toggleHeading({ level: 5 }).run()"
                  v-b-tooltip.hover
                  :title="$t('heading') + ' 5'"
                >
                  H5
                </b-button>
                <b-button
                  :variant="editor.isActive('heading', { level: 6 }) ? '' : 'outline'"
                  @click="editor.chain().focus().toggleHeading({ level: 6 }).run()"
                  v-b-tooltip.hover
                  :title="$t('heading') + ' 6'"
                >
                  H6
                </b-button> -->
          </b-button-group>

          <b-button-group>
            <b-button
              :variant="editor.isActive('bulletList') ? 'light' : 'outline'"
              :style="editor.isActive('bulletList') ? 'opacity: 0.9' : ''"
              @click="editor.chain().focus().toggleBulletList().run()"
              v-b-tooltip.hover
              :title="$t('unorderedlist')"
              size="sm"
            >
              <b-icon-list-ul :variant="editor.isActive('bulletList') ? 'primary' : 'white'" />
            </b-button>

            <b-button
              :variant="editor.isActive('orderedList') ? 'light' : 'outline'"
              :style="editor.isActive('orderedList') ? 'opacity: 0.9' : ''"
              @click="editor.chain().focus().toggleOrderedList().run()"
              v-b-tooltip.hover
              :title="$t('orderedlist')"
              size="sm"
            >
              <b-icon-list-ol :variant="editor.isActive('orderedList') ? 'primary' : 'white'" />
            </b-button>

            <b-button
              v-show="showMenu == 'advanced'"
              :variant="'outline'"
              @click="editor.chain().focus().setPageBreak().run()"
              v-b-tooltip.hover
              :title="$tc('pageBreak')"
              size="sm"
            >
              <b-icon-file-break variant="white" />
            </b-button>
          </b-button-group>

          <!-- <button
          @click="editor.chain().focus().toggleCodeBlock().run()"
          :class="{ 'is-active': editor.isActive('codeBlock') }"
        >
          code block
        </button> -->
          <!--<button
            @click="editor.chain().focus().toggleBlockquote().run()"
            :class="{ 'is-active': editor.isActive('blockquote') }"
          >
            <icon name="quote" />
          </button>-->

          <b-button-group>
            <!-- <b-button
                  :variant="editor.isActive('paragraph') ? '' : 'outline'"
                  @click="addNewLine"
                  :class="{ 'is-active': editor.isActive('paragraph') }"
                  v-b-tooltip.hover
                  :title="$t('paragraph')"
                >
                  <icon name="paragraph" />
                </b-button> -->

            <b-button
              v-show="showMenu == 'advanced'"
              :variant="editor.isActive('hr') ? '' : 'outline'"
              @click="editor.chain().focus().setHorizontalRule().run()"
              v-b-tooltip.hover
              :title="$t('horizontalbreak')"
              size="sm"
            >
              <b-icon-dash variant="white" />
            </b-button>
          </b-button-group>

          <b-button-group>
            <b-button
              v-show="showMenu == 'advanced'"
              :variant="editor.isActive('table') ? 'light' : 'outline'"
              :style="editor.isActive('table') ? 'opacity: 0.9' : ''"
              @click="
                editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: false, resizable: true }).run();
                editor.chain().focus().setParagraph().run();
              "
              v-b-tooltip.hover
              :title="$t('table')"
              size="sm"
            >
              <b-icon-grid3x3 :variant="editor.isActive('table') ? 'primary' : 'white'" />
            </b-button>
          </b-button-group>

          <b-button-group>
            <b-button
              v-show="showMenu == 'advanced'"
              :variant="editor.isActive('ResizableImage') ? '' : 'outline'"
              @click="addImage"
              v-b-tooltip.hover
              :title="$tc('image', 1)"
              size="sm"
            >
              <b-icon-images variant="white" />
            </b-button>
          </b-button-group>

          <!--<button @click="editor.chain().focus().setHardBreak().run()">hard break</button>-->

          <b-button-group>
            <b-button
              v-show="showMenu == 'advanced'"
              variant="outline"
              @click="editor.chain().focus().undo().run()"
              v-b-tooltip.hover
              :title="$t('undo')"
              size="sm"
            >
              <b-icon-arrow-counterclockwise variant="white" />
            </b-button>

            <b-button
              v-show="showMenu == 'advanced'"
              variant="outline"
              @click="editor.chain().focus().redo().run()"
              v-b-tooltip.hover
              :title="$t('redo')"
              size="sm"
            >
              <b-icon-arrow-clockwise variant="white" />
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>

      <b-row v-show="!disabled && showMenu == 'dynamic' && editor.isEmpty && !showDynamicMenu">
        <span class="ml-4 text-muted" @click="onClickFocus()">
          {{ $tc("placeholder") }}
        </span>
      </b-row>
      <b-row
        v-if="
          !disabled &&
          (showTextColor || showHighlightColor || editor.isActive('table') || editor.isActive('ResizableImage'))
        "
      >
        <b-col>
          <b-button-group v-if="showTextColor">
            <b-button
              @click="editor.chain().focus().setColor('purple').run()"
              :class="{ 'is-active': editor.isActive('textStyle', { color: 'purple' }) }"
              :style="{ 'background-color': 'purple', color: 'purple' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().setColor('pink').run()"
              :class="{ 'is-active': editor.isActive('textStyle', { color: 'pink' }) }"
              :style="{ 'background-color': 'pink', color: 'pink' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().setColor('red').run()"
              :class="{ 'is-active': editor.isActive('textStyle', { color: 'red' }) }"
              :style="{ 'background-color': 'red', color: 'red' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().setColor('orange').run()"
              :class="{ 'is-active': editor.isActive('textStyle', { color: 'orange' }) }"
              :style="{ 'background-color': 'orange', color: 'orange' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().setColor('yellow').run()"
              :class="{ 'is-active': editor.isActive('textStyle', { color: 'yellow' }) }"
              :style="{ 'background-color': 'yellow', color: 'yellow' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().setColor('blue').run()"
              :class="{ 'is-active': editor.isActive('textStyle', { color: 'blue' }) }"
              :style="{ 'background-color': 'blue', color: 'blue' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().setColor('teal').run()"
              :class="{ 'is-active': editor.isActive('textStyle', { color: 'teal' }) }"
              :style="{ 'background-color': 'teal', color: 'teal' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().setColor('green').run()"
              :class="{ 'is-active': editor.isActive('textStyle', { color: 'green' }) }"
              :style="{ 'background-color': 'green', color: 'green' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().setColor('black').run()"
              :class="{ 'is-active': editor.isActive('textStyle', { color: 'black' }) }"
              :style="{ 'background-color': 'black', color: 'black' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().unsetColor().run()"
              :class="{ 'is-active': editor.isActive('textStyle', { color: 'black' }) }"
              style="background-color: white; color: red; position: relative"
            >
              <span
                style="
                  position: absolute;
                  top: 52%;
                  left: 50%;
                  transform: translate(-50%, -50%) rotate(-45deg);
                  width: 135%;
                  height: 2px;
                  background-color: red;
                "
              ></span>
              <span style="color: white">-</span>
            </b-button>
          </b-button-group>

          <b-button-group v-if="showHighlightColor">
            <b-button
              @click="editor.chain().focus().toggleHighlight({ color: 'purple' }).run()"
              :class="{ 'is-active': editor.isActive('highlight', { color: 'purple' }) }"
              :style="{ 'background-color': 'purple', color: 'purple' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().toggleHighlight({ color: 'pink' }).run()"
              :class="{ 'is-active': editor.isActive('highlight', { color: 'pink' }) }"
              :style="{ 'background-color': 'pink', color: 'pink' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().toggleHighlight({ color: 'red' }).run()"
              :class="{ 'is-active': editor.isActive('highlight', { color: 'red' }) }"
              :style="{ 'background-color': 'red', color: 'red' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().toggleHighlight({ color: 'orange' }).run()"
              :class="{ 'is-active': editor.isActive('highlight', { color: 'orange' }) }"
              :style="{ 'background-color': 'orange', color: 'orange' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().toggleHighlight({ color: 'yellow' }).run()"
              :class="{ 'is-active': editor.isActive('highlight', { color: 'yellow' }) }"
              :style="{ 'background-color': 'yellow', color: 'yellow' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().toggleHighlight({ color: 'blue' }).run()"
              :class="{ 'is-active': editor.isActive('highlight', { color: 'blue' }) }"
              :style="{ 'background-color': 'blue', color: 'blue' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().toggleHighlight({ color: 'teal' }).run()"
              :class="{ 'is-active': editor.isActive('highlight', { color: 'teal' }) }"
              :style="{ 'background-color': 'teal', color: 'teal' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().toggleHighlight({ color: 'green' }).run()"
              :class="{ 'is-active': editor.isActive('highlight', { color: 'green' }) }"
              :style="{ 'background-color': 'green', color: 'green' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().toggleHighlight({ color: 'black' }).run()"
              :class="{ 'is-active': editor.isActive('highlight', { color: 'black' }) }"
              :style="{ 'background-color': 'black', color: 'black' }"
            >
              -
            </b-button>
            <b-button
              @click="editor.chain().focus().unsetHighlight().run()"
              :class="{ 'is-active': editor.isActive('highlight', { color: 'black' }) }"
              style="background-color: white; color: red; position: relative"
            >
              <span
                style="
                  position: absolute;
                  top: 52%;
                  left: 50%;
                  transform: translate(-50%, -50%) rotate(-45deg);
                  width: 135%;
                  height: 2px;
                  background-color: red;
                "
              ></span>
              <span style="color: white">-</span>
            </b-button>
          </b-button-group>
          <b-button-group v-show="editor.isActive('table')">
            <b-button
              variant="outline"
              @click="editor.chain().focus().addColumnBefore().run()"
              v-b-tooltip.hover
              :title="$t('addColBefore')"
            >
              <icon name="add_col_before" />
            </b-button>
            <b-button
              variant="outline"
              @click="editor.chain().focus().addColumnAfter().run()"
              v-b-tooltip.hover
              :title="$t('addColAfter')"
            >
              <icon name="add_col_after" />
            </b-button>
            <b-button
              variant="outline"
              @click="editor.chain().focus().deleteColumn().run()"
              v-b-tooltip.hover
              :title="$t('deleteCol')"
            >
              <icon name="delete_col" />
            </b-button>
            <b-button
              variant="outline"
              @click="editor.chain().focus().addRowBefore().run()"
              v-b-tooltip.hover
              :title="$t('addRowBefore')"
            >
              <icon name="add_row_before" />
            </b-button>
            <b-button
              variant="outline"
              @click="editor.chain().focus().addRowAfter().run()"
              v-b-tooltip.hover
              :title="$t('addRowAfter')"
            >
              <icon name="add_row_after" />
            </b-button>
            <b-button
              variant="outline"
              @click="editor.chain().focus().deleteRow().run()"
              v-b-tooltip.hover
              :title="$t('deleteRow')"
            >
              <icon name="delete_row" />
            </b-button>
            <b-button
              variant="outline"
              @click="editor.chain().focus().deleteTable().run()"
              v-b-tooltip.hover
              :title="$t('deleteTable')"
            >
              <icon name="delete_table" />
            </b-button>
            <b-button
              variant="outline"
              @click="editor.chain().focus().mergeCells().run()"
              v-b-tooltip.hover
              :title="$t('mergeCells')"
            >
              <icon name="merge-cells-horizontal" />
            </b-button>
            <b-button
              variant="outline"
              @click="editor.chain().focus().splitCell().run()"
              v-b-tooltip.hover
              :title="$t('splitCells')"
            >
              <icon name="split-cells-horizontal" />
            </b-button>
          </b-button-group>
          <b-button-group v-show="editor.isActive('ResizableImage')">
            <b-button
              :variant="
                editor.isActive('ResizableImage') && editor.getAttributes('ResizableImage').width == 200
                  ? ''
                  : 'outline'
              "
              @click="
                editor.commands.updateAttributes('ResizableImage', {
                  width: 200
                })
              "
            >
              {{ $t("small") }}
            </b-button>
            <b-button
              :variant="
                editor.isActive('ResizableImage') && editor.getAttributes('ResizableImage').width == 500
                  ? ''
                  : 'outline'
              "
              @click="
                editor.commands.updateAttributes('ResizableImage', {
                  width: 500
                })
              "
            >
              {{ $t("medium") }}
            </b-button>
            <b-button
              :variant="
                editor.isActive('ResizableImage') && editor.getAttributes('ResizableImage').width == '100%'
                  ? ''
                  : 'outline'
              "
              @click="
                editor.commands.updateAttributes('ResizableImage', {
                  width: '100%'
                })
              "
            >
              {{ $t("large") }}
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>

      <b-row @click="onClickFocus()">
        <b-col>
          <div>
            <!-- There are 3 bubble menus for the 3 different scenarios, depending on what isLinkActive and linkOpensInNewTab are. -->
            <!-- Preferably, there should only be one bubble menu and with the conditions tied to the buttons instead, -->
            <!-- but that stopped working for some unknown reason, and therefore this solution was implemented. -->
            <bubble-menu :editor="editor" :tippy-options="{ duration: 100 }" v-if="editor" v-show="!isLinkActive">
              <template v-slot:default>
                <b-button @click="setLink" v-b-tooltip.hover :title="$tc('openLinkInSameTab')">
                  <icon name="link" />
                </b-button>
                <b-button @click="setLinkNewTab" v-b-tooltip.hover :title="$tc('openLinkInNewTab')">
                  <icon name="external-link" />
                </b-button>
              </template>
            </bubble-menu>

            <bubble-menu
              :editor="editor"
              :tippy-options="{ duration: 100 }"
              v-if="editor"
              v-show="isLinkActive && !linkOpensInNewTab"
            >
              <template v-slot:default>
                <b-button
                  @click="setLink"
                  v-b-tooltip.hover
                  :title="$tc('openLinkInSameTab')"
                  class="custom-active-link"
                >
                  <icon name="link" />
                </b-button>
                <b-button @click="setLinkNewTab" v-b-tooltip.hover :title="$tc('openLinkInNewTab')">
                  <icon name="external-link" />
                </b-button>
                <b-button @click="unLink" v-b-tooltip.hover :title="$tc('unlink')">
                  <icon name="link-unlink" />
                </b-button>
              </template>
            </bubble-menu>

            <bubble-menu
              :editor="editor"
              :tippy-options="{ duration: 100 }"
              v-if="editor"
              v-show="isLinkActive && linkOpensInNewTab"
            >
              <template v-slot:default>
                <b-button @click="setLink" v-b-tooltip.hover :title="$tc('openLinkInSameTab')">
                  <icon name="link" />
                </b-button>
                <b-button
                  @click="setLinkNewTab"
                  v-b-tooltip.hover
                  :title="$tc('openLinkInNewTab')"
                  class="custom-active-link"
                >
                  <icon name="external-link" />
                </b-button>
                <b-button @click="unLink" v-b-tooltip.hover :title="$tc('unlink')">
                  <icon name="link-unlink" />
                </b-button>
              </template>
            </bubble-menu>
          </div>
          <editor-content class="editor__content" :editor="editor" :style="dynamicStyles" />
        </b-col>
      </b-row>

      <b-row v-show="!disabled && showMenu == 'advanced' && p_subMenu">
        <b-col>
          <b-button-group>
            <b-button
              :variant="editor.isActive('bold') ? '' : 'outline'"
              @click="editor.chain().focus().toggleBold().run()"
              :disabled="!editor.can().chain().focus().toggleBold().run()"
              v-b-tooltip.hover
              :title="$t('bold')"
            >
              <b-icon-type-bold />
            </b-button>

            <b-button
              :variant="editor.isActive('heading', { level: 1 }) ? '' : 'outline'"
              @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
              v-b-tooltip.hover
              :title="$t('heading') + ' 1'"
            >
              <b-icon-type-h1 />
            </b-button>

            <b-button
              :variant="editor.isActive('heading', { level: 2 }) ? '' : 'outline'"
              @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
              v-b-tooltip.hover
              :title="$t('heading') + ' 2'"
            >
              <b-icon-type-h2 />
            </b-button>

            <b-button
              :variant="editor.isActive('heading', { level: 3 }) ? '' : 'outline'"
              @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
              v-b-tooltip.hover
              :title="$t('heading') + ' 3'"
            >
              <b-icon-type-h3 />
            </b-button>
          </b-button-group>

          <b-button-group>
            <b-button
              :variant="editor.isActive('bulletList') ? '' : 'outline'"
              @click="editor.chain().focus().toggleBulletList().run()"
              v-b-tooltip.hover
              :title="$t('unorderedlist')"
            >
              <b-icon-list-ul />
            </b-button>

            <b-button
              :variant="editor.isActive('orderedList') ? '' : 'outline'"
              @click="editor.chain().focus().toggleOrderedList().run()"
              v-b-tooltip.hover
              :title="$t('orderedlist')"
            >
              <b-icon-list-ol />
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>

      <b-row v-if="advancedEdit">
        <b-col>
          <b-form-textarea
            v-model="advancedContent"
            rows="20"
            max-rows="20"
            @input="advancedEditChanged()"
          ></b-form-textarea>
        </b-col>
      </b-row>

      <b-row @click="onClickFocus()">
        <input type="file" class="no-screen no-print" ref="selectImageInput" accept="image/*" @change="onImagePicked" />
      </b-row>

      <b-row v-if="!disabled && p_showAdvancedButton" @click="onClickFocus()">
        <b-col md="12" class="text-right">
          <b-button-group>
            <b-button variant="link" @click="toggleAdvanced()" v-b-tooltip.hover :title="$t('advancedMode')">
              {{ $t("advanced") }}
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Icon from "./Icons/TextEditorIcons";
import Highlight from "@tiptap/extension-highlight";
import { Color } from "@tiptap/extension-color";
import TextStyle from "@tiptap/extension-text-style";
import TextAlign from "@tiptap/extension-text-align";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import Table from "@tiptap/extension-table";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import { PageBreak } from "./extension-pagebreak";
import TableRow from "@tiptap/extension-table-row";
import { BubbleMenu, Editor, EditorContent } from "@tiptap/vue-2";

import Link from "@tiptap/extension-link";
import ResizableImage from "./ResizableImage";
import i18n from "@/helpers/language";
import { mapActions } from "vuex";

export default {
  name: "TextEditor",
  props: {
    id: { type: Number },
    type: { type: String },
    disabled: { type: Boolean, default: true },
    value: { type: String },
    minHeight: { type: Number, default: 200 },
    maxHeight: { type: Number, default: 600 },
    p_showMenu: { type: String, default: "advanced" },
    p_showAdvancedButton: { type: Boolean, default: false },
    p_subMenu: { type: Boolean, default: false },
    p_click: { type: Number, default: 0 },
    text_area_question: { type: Boolean, default: false }
  },
  components: {
    EditorContent,
    BubbleMenu,
    Icon
  },
  data() {
    return {
      editor: null,
      emitAfterOnUpdate: false,
      isLinkActive: false,
      linkUrl: null,
      linkMenuIsActive: false,
      linkOpensInNewTab: false,
      showTextColor: false,
      showHighlightColor: false,
      showMenu: this.p_showMenu,
      advancedEdit: false,
      advancedContent: this.value,
      showDynamicMenu: false
    };
  },
  mounted() {
    this.editor = new Editor({
      onUpdate: () => {
        this.$emit("input", this.editor.getHTML());
        this.advancedContent = this.editor.getHTML();
        this.setPendingChanges(true);
      },
      editable: !this.disabled,
      content: this.value,
      extensions: [
        StarterKit,
        Underline,
        TextAlign.configure({
          types: ["heading", "paragraph"]
        }),
        TextStyle,
        Color,
        Highlight.configure({
          multicolor: true
        }),
        Table.configure({
          resizable: true
        }),
        TableRow,
        TableHeader,
        TableCell,
        PageBreak,
        Link.configure({
          HTMLAttributes: {
            target: null
          },
          openOnClick: false
        }),
        ResizableImage.configure({
          inline: true,
          allowBase64: true,
          HTMLAttributes: {
            class: "ResizableImage"
          }
        })
      ]
    });

    if (!this.disabled && this.showMenu != "dynamic") {
      this.editor.commands.focus();
    }

    this.editor.on("selectionUpdate", () => {
      this.isLinkActive = this.editor.isActive("link");

      if (this.isLinkActive) {
        // target is null if it is not set
        if (this.editor.getAttributes("link").target === "_blank") {
          this.linkOpensInNewTab = true;
        } else {
          this.linkOpensInNewTab = false;
        }
      }
    });
  },
  computed: {
    dynamicStyles() {
      let styles = {};

      if (this.disabled) {
        styles.minHeight = `${this.minHeight}px`;
        styles.maxHeight = "100%";
      } else {
        styles.minHeight = `${this.minHeight}px`;
        styles.maxHeight = `${this.maxHeight}px`;
      }

      return styles;
    }
  },
  watch: {
    p_showMenu(value) {
      this.showMenu = value;
    },
    p_click(value) {
      if (this.showMenu == "dynamic") {
        this.showDynamicMenu = false;
      }
    },
    disabled(value) {
      this.editor.setOptions({
        editable: !value
      });

      if (!value) {
        this.editor.commands.focus();
      }
      this.advancedEdit = false;
    },
    value(value) {
      // HTML
      const isSame = this.editor.getHTML() === value;

      // JSON
      // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

      if (isSame) {
        return;
      }

      this.editor.commands.setContent(value, false);
    }
  },
  methods: {
    ...mapActions("app", ["setPendingChanges"]),
    advancedEditChanged() {
      this.editor.commands.setContent(this.advancedContent, false);
      this.$emit("input", this.advancedContent);
    },
    toggleAdvanced() {
      this.advancedEdit = !this.advancedEdit;
      this.advancedContent = this.editor.getHTML();
    },
    onClickFocus() {
      if (this.showMenu == "dynamic") {
        this.showDynamicMenu = true;
      }
      if (!this.advancedEdit) {
        this.editor.commands.focus();
      }
    },
    addNewLine() {
      // const endPos = props.getPos() + props.node.nodeSize;
      // // I focus the start of the editor because
      // // when the cursor is at the end of the node below which
      // // we want to add a block, it doesn't focus the next block
      // props.editor.commands.focus("start");
      // props.editor.chain().insertContentAt(endPos, { type: "paragraph" }).focus(endPos).run();
    },
    setLinkNewTab() {
      const previousUrl = this.editor.getAttributes("link").href;
      const url = window.prompt("URL", previousUrl);

      // cancelled
      if (url === null) {
        return;
      }

      // empty
      if (url === "") {
        this.editor.chain().focus().extendMarkRange("link").unsetLink().run();
        return;
      }

      // update link
      this.editor
        .chain()
        .focus()
        .extendMarkRange("link")
        .setLink({
          href: url,
          target: "_blank"
        })
        .run();

      this.isLinkActive = true;
      this.linkOpensInNewTab = true;
    },
    setLink() {
      const previousUrl = this.editor.getAttributes("link").href;
      const url = window.prompt("URL", previousUrl);

      // cancelled
      if (url === null) {
        return;
      }

      // empty
      if (url === "") {
        this.editor.chain().focus().extendMarkRange("link").unsetLink().run();

        return;
      }

      // update link
      this.editor.chain().focus().extendMarkRange("link").setLink({ href: url }).run();

      this.isLinkActive = true;
      this.linkOpensInNewTab = false;
    },
    unLink() {
      this.editor.chain().focus().unsetLink().run();
      this.isLinkActive = false;
    },
    addImage() {
      this.$refs.selectImageInput.click();
    },
    onImagePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.editor.chain().focus().setImage({ src: fileReader.result }).run();
        this.editor.chain().focus().setParagraph().run();
      });
      fileReader.readAsDataURL(files[0]);
    }
  },

  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy();
    }
  }
};
</script>

<style lang="scss">
@import "./TextEditor.scss";

.editor__content {
  overflow-y: auto;
}

.editor p.is-editor-empty:first-child::before {
  content: attr(data-empty-text);
  float: left;
  color: #aaa;
  pointer-events: none;
  height: 0;
  font-style: italic;
}

.ProseMirror p {
  margin: 1em 0;
}

.custom-active-link {
  background: var(--primary) !important;
}
</style>
